import i18next from 'i18next';
import pt from './pt-br/translation.json';

i18next.init({
  lng: 'pt-br',
  interpolation: { escapeValue: false },
  resources: {
    pt,
  },
});

export type translations = typeof pt;

export default i18next;
